import React, { useState } from 'react';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';

export function formatTheGivenInput(city) {
  try {
    if (!city || city === '') {
      return '';
    }
    return city.trim().split(' ').map((word) => word.charAt(0).toUpperCase() + word?.toLowerCase().slice(1)).join(' ');
  } catch (error) {
    console.error('Error in formatTheGivenInput:', error);
  }
  return '';
}

export const testId = 'activity-lod-list-item-details';

export const ItemDetails = ({ device }) => {

  const [expanded, setExpanded] = useState(false);

  const handleCollapseLog = () => { setExpanded((prevState) => !prevState); };

  const checkProp = (prop) => (!prop || prop === '' ? 'Unknown' : prop);

  const locationDetails = () => {
    const city = checkProp(formatTheGivenInput(device?.location?.city));
    const country = checkProp(device?.location?.country);
    const region = checkProp(device?.location?.region?.toUpperCase());

    if (city === 'Unknown' && region === 'Unknown') {
      return {
        REGION: 'Unknown',
        COUNTRY: country === 'Unknown' ? 'Unknown' : country
      };
    }
    return {
      REGION: `${city}, ${region}`,
      COUNTRY: country
    };
  };

  const deviceDetails = () => {
    const os = checkProp(device?.os?.type);
    const browser = checkProp(device?.browser?.type);

    if (os === 'Unknown' && browser === 'Unknown') {
      return {
        OS: 'Unknown',
        BROWSER: ''
      };
    }
    return {
      OS: os,
      BROWSER: browser
    };
  };

  return (
    <>
      {expanded && (
        <>
          <div
            data-component="ItemDetails"
            className="sui-flex sui-flex-row sui-flex-1 sui-justify-between sui-pl-8"
          >
            <div className="sui-flex sui-flex-row sui-w-6/12 sui-gap-2">
              <Typography variant="body-lg" weight="bold">Near</Typography>
            </div>
            <div className="sui-flex sui-flex-col sui-w-6/12 sui-text-right">
              <Typography variant="body-base">{locationDetails().REGION}</Typography>
              <Typography variant="body-base">{locationDetails().COUNTRY}</Typography>
            </div>
          </div>
          <div className="sui-flex sui-flex-row sui-flex-1 sui-justify-between sui-pl-8">
            <div className="sui-flex sui-flex-row sui-w-6/12 sui-gap-2">
              <Typography variant="body-lg" weight="bold">Using</Typography>
            </div>
            <div className="sui-flex sui-flex-col sui-w-6/12 sui-text-right">
              <Typography variant="body-base">{deviceDetails().OS}</Typography>
              <Typography variant="body-base">{deviceDetails().BROWSER}</Typography>
            </div>
          </div>
        </>
      )}
      <div className="sui-ml-8">
        <Button variant="text" data-testid={testId} onClick={handleCollapseLog}>
          {expanded ? 'Hide Details' : 'Show Details'}
          <div className="sui-pl-2">
            {expanded ? <ArrowUp size="small" /> : <ArrowDown size="small" />}
          </div>
        </Button>
      </div>
    </>
  );
};

ItemDetails.propTypes = {
  device: PropTypes.shape({
    browser: PropTypes.objectOf(PropTypes.string),
    ip: PropTypes.string,
    location: PropTypes.objectOf(PropTypes.string),
    os: PropTypes.objectOf(PropTypes.string),
  })
};

ItemDetails.defaultProps = {
  device: {
    browser: {
      type: 'Unknown'
    },
    ip: 'IP',
    location: {
      city: 'Unknown',
      country: 'Unknown',
      region: 'Unknown'
    },
    os: {
      type: 'Unknown',
      version: 'Unknown'
    },
  }
};

ItemDetails.defaultProps.device.location = ItemDetails
  .defaultProps.device.location || { city: 'Unknown', country: 'Unknown', region: 'Unknown' };

ItemDetails.displayName = 'AccountActivityListItemDetails';
